import { Box, Button, Grid, InputAdornment } from "@mui/material";
import React from "react";
import CoTextField from "../../../components/CoTextField";
import Field from "../../../components/Field";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import useLoader from "../../../Loader/useLoader";
import { formatCurrency } from "../../../utils/normalizers";

const CurrencyConversion = () => {
  const [showLoader, hideLoader] = useLoader();
  const userSchema = yup.object({
    usa: yup.string().required("Enter Value in USA"),
  });

  const {
    control,
    watch,
    setValue,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(userSchema),
    defaultValues: {
      usa: 1.00,
      india: "",
      canada: "",
    },
  });

  const onSubmit = async (data) => {
    showLoader();
    try {
      
      const response = await axios.get(
        `https://api.exchangerate-api.com/v4/latest/USD`
      );

      if (response.data && response.data.rates) {
        const rates = response.data.rates;

        const amountUSD = parseFloat(data?.usa) || 0;
        const india = (amountUSD * rates.INR).toFixed(2);
        const canada = (amountUSD * rates.CAD).toFixed(2);

        setValue("india", india);
        setValue("canada", canada);
      }
    } catch (error) {
      console.error("Currency conversion error:", error);
      // Handle error appropriately
    } finally {
      hideLoader();
    }
  };

  return (
    <>
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Grid
          item
          xs={6}
          sx={{
            display: "flex",
            alignItems: "center",
            padding: 2,
            backgroundColor: "#f5f5f5",
            borderRadius: 1,
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <Grid
            container
            spacing={2}
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Grid
              item
              xs={12}
              md={12}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
              }}
            >
              <h1>Currency Conversion</h1>
              <p>Convert between different currencies.</p>
            </Grid>
          </Grid>
          <Box
            sx={{
              padding: "20px",
              border: "solid 1px #616161",
              borderRadius: "10px",
              width: "100%",
              backgroundColor: "#fff",
            }}
          >
            <Grid
              container
              spacing={2}
              sx={{ display: "flex", justifyContent: "center" }}
            >
              <Grid item xs={6} sx={{ alignItems: "center", display: "flex" }}>
                <Field
                  label="USA"
                  required
                  error={errors?.usa?.message}
                  showError={errors?.usa?.message}
                >
                  <CoTextField
                    control={control}
                    name="usa"
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
              <Grid item xs={6}>
                <Field label="India">
                  <CoTextField
                    control={control}
                    name="india"
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">₹</InputAdornment>
                    }
                  />
                </Field>
                <Field label="Canada">
                  <CoTextField
                    control={control}
                    name="canada"
                    normalizers={[formatCurrency]}
                    startAdornment={
                      <InputAdornment position="start">C$</InputAdornment>
                    }
                  />
                </Field>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                }}
              >
                <Button
                  variant="outlined"
                  sx={{ textTransform: "capitalize" }}
                  onClick={() => {
                    handleSubmit(onSubmit)();
                  }}
                >
                  Currency Conversion
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: "capitalize", height: "fit-content" }}
            >
              Save
            </Button>
            <Button
              variant="outlined"
              sx={{ textTransform: "capitalize", height: "fit-content" }}
              onClick={() => {
                reset();
              }}
            >
              Clear
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CurrencyConversion;
